export const SLOT_STATUSES = {
  AVAILABLE: "available",
  SOLDOUT: "soldout",
  BOOKED: "booked",
  RESERVED: "reserved",
  PRELIMINARY: "preliminary",
  PARTIAL: "partial",
  DURATION_BLOCKED: "duration_blocked",
  HOLIDAY_BLOCKED: "holiday_blocked",
  UNAVAILABLE: "unavailable", // No studios available (but no actual booking)
  INSUFFICIENT_TIME: "insufficient_time", // Slot would cause overlap with existing bookings
} as const;

export const CUSTOMER_TYPES = {
  PRIVATE: "private",
  CORPORATE: "corporate",
  ROADSHOW: "roadshow",
} as const;
